import { ReactNode, useState, useMemo } from 'react';
import clsx from 'clsx';
import Sidebar from './Sidebar';
import Header from './Header';
import { SidebarContext } from './Sidebar';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [isExpanded, setIsExpanded] = useState(true);
  const sidebarContextValue = useMemo(() => ({
    isExpanded,
    setIsExpanded
  }), [isExpanded]);

  return (
    <SidebarContext.Provider value={sidebarContextValue}>
      <div className="min-h-screen bg-gray-100">
        <Sidebar />
        <div className={clsx(
          "transition-all duration-200 ease-in-out",
          isExpanded ? "lg:ml-64" : "lg:ml-20"
        )}>
          <Header />
          <main className="p-4 md:p-6">
            <div className="max-w-7xl mx-auto">
              {children}
            </div>
          </main>
        </div>
      </div>
    </SidebarContext.Provider>
  );
}